import { createContext, useContext, useState } from "react";

interface AuthContextInterface {
  loggedUser?: any;
  token?: string;
  setLoggedUser: React.Dispatch<React.SetStateAction<any | undefined>>;
  setToken: React.Dispatch<React.SetStateAction<string | undefined>>;
  newNotifications?: number;
  setNewNotifications: React.Dispatch<React.SetStateAction<number | undefined>>;
}

const AuthContext = createContext<AuthContextInterface>(
  {} as AuthContextInterface
);

export const AuthProvider = ({ children }: React.PropsWithChildren) => {
  const [loggedUser, setLoggedUser] = useState<any>();
  const [token, setToken] = useState<string>();
  const [newNotifications, setNewNotifications] = useState<
    number | undefined
  >();

  return (
    <AuthContext.Provider
      value={{
        loggedUser,
        setLoggedUser,
        token,
        setToken,
        newNotifications,
        setNewNotifications,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
